import { AppStoreConfig } from '@ddt-web/data-service';

export const PdfGenerateStoreConfig: AppStoreConfig = {
	details: { name: 'details', storeAsList: true },
	positionDetails: { name: 'positionDetails', storeAsList: true },
	engagementPortfolios: { name: 'engagementPortfolios', storeAsList: true },
	reportConfig: { name: 'reportConfig', storeAsList: false, defaultValue: [], portfolioIndependent: true }
};

export const StoreFeatureName = 'reportConfigStore';
